export default __webpack_public_path__ + "static/media/us2.0d553fed.jpeg";